module.exports = __webpack_public_path__ + "static/index/img/baikal-301.5c613e72.jpg";